import React, { use, useEffect, useState } from "react";
import HorizontalSplitIcon from "@mui/icons-material/HorizontalSplit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Form from "react-bootstrap/Form";
import Avatar from "../css/Avatar1.png";
import Bell from  "../css/bellIcon.png"
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import { matchPath, useLocation } from "react-router-dom";
import ModalBox from "../components/modal/ModalBox";
import { Input } from "../components/Form";
import { getNotificationApi, markRead } from "../services/notificationManagement";
import { toastMessage } from "../utils/toastMessage";

const ROUTE_ARR = {
  "/consultant-payout": ["payoutList"],
  "/music-category": ["musicCategory", "musicList"],
  "/user": ["userList", "useDetailList", "deletedUserList"],
  "/consultant-management": ["consultantList", "deletedConsultantList"],
  "/category": ["category", "categoryMedia"],
  "/banner": [],
  "/dashboard": [],
  "/meditation-category": ["meditationCategory"],
  "/training-management": ["trainingCategory", "trainingList"],
  "/image-management": ["imageList"],
  "/explore-management": ["exploreList"],
  "/request-management": ["requestList"],
  "/discount-management": ["discountList"],
  "/notification-management": ["notificationList"],
  "/horoscope-management": ["horoscopeList"],
  "/live-management": ["liveList"],
  "/support-management": ["queryList", "supportListType"],
  "/form-16A": ["formList"],
  "/concern-management": ["concern", "remedyList"],
  "/transaction-management": ["transaction"],
};
export default function Header() {
  // const name = localStorage.getItem('auction_userName')
const [modal, setModal] = useState(false)
const [message, setMessage] = useState([])
const [readId , setReadId] = useState('')
const [notificationCount , setNotificationCount] = useState(0)
  const location = useLocation();
const fetchNotification = async () => {
 try {
  const res = await getNotificationApi({
    page: 1,
    limit: 10,
  });
  if(res?.status === 200){
    setMessage(res?.data?.result?.list)
    if(!res?.data?.result?.list?.readByAdmin){
      console.log("i am here")
    setNotificationCount(notificationCount => notificationCount+1)
    toastMessage("You received new notification", )
    }
  }
 } catch (error) {
  console.log(error,"Error in Fetching Notification");
 }
}
const readNotification = async () => {
  try {
    console.log("Read Id===>",readId)
  const res = await markRead({ notificationId: readId });
    if(res?.status === 200){
      console.log("Read Notification Successfully")
    }
  } catch (error) {
    console.log(error, "Error in Fetching Notification");
  }
};

  useEffect(() => {
    Object.entries(ROUTE_ARR).forEach(([key, val]) => {
      const match = matchPath(
        {
          path: `${key}/*`,
          exact: false,
          strict: false,
        },
        location.pathname
      );

      // if match then remove all previous keys
      // console.log(match)
      if (match) {
        try {
          let tempVar = {};
          let localData = JSON.parse(localStorage.getItem("admin"));
          val.forEach((item) => {
            tempVar = { ...tempVar, [item]: localData[item] };
          });
          localStorage.setItem("admin", JSON.stringify(tempVar));
        } catch (err) {
          // localStorage.removeItem("admin") 
        }
      }
    });
  }, [location]);
  useEffect(() => {
    fetchNotification()
  }, ['/dashboard'])
  console.log("Notification Count===>",notificationCount)
  return (
    <>

    <div className="mainHead">
      <div className="header">
        <ViewHeadlineIcon
          style={{
            color: "white",
            fontSize: 35,
            cursor: "pointer",
          }}
        />

        <div className="mx-10" style={{ position: 'relative' }}>
        {notificationCount !== 0 && (
            <div
              style={{
                paddingVertical: 10,
                borderRadius: 20,
                backgroundColor: '#f00',
                alignItems: 'center',
                position: 'absolute',
                paddingHorizontal: notificationCount > 9 ? 10 : 10,
                top: -4,
                left: -10,
              }}
            >
              <p
                style={{
                  padding: '5px 10px',
                  fontSize: 10,
                  color: 'white',
                }}
              >
                {notificationCount > 9 ? '9+' : notificationCount}
              </p>
            </div>
          )}
          <img 
            onClick={() => {
              setModal(true)
            }}
            className="mx-2 fs-6"
            style={{ height: "30px", width: "30px" }}
            src={Bell}
          />
          
          <img
            style={{ height: "40px", width: "40px" }}
            src={Avatar}
            alt="profile"
          />
          {/* <span className='mx-2 fs-6'>{name}</span> comes from Api Name */}
          <span className="mx-2 fs-6">Admin</span>
        </div>
        {/* <Link>
          <figure>
            <img alt="" src="./images/user.png" />
          </figure>
          {empName}
        </Link> */}
        {/* <div className="logo"><FaBars /></div> */}
        {/* <div className="header_notification"> <NotificationsIcon />
        <span className='bell'> 2</span> 

    <Form.Select aria-label="Default select example">
      <option> English</option>
      <option value="1">One</option>
      <option value="2">Two</option>
      <option value="3">Three</option>
    </Form.Select>


</div> */}
      </div>
    </div>
    <ModalBox
  status={modal}
  onClose={() => {
    setModal(false);
  }}
  title={"Notification"}
  closeIcon
  size={"sm"}
  custom
  customizedFooter={
    <div
      style={{
        maxHeight: "300px", // Adjust height as needed
        overflowY: "auto",
        padding: "10px",
      }}
    >
      {message.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              padding: "14px 24px",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "#4A4A4A",
                margin: 0,
                padding: "10px",
                backgroundColor: item?.readByAdmin ? "#ffffff" : "#EDEDEE",
              }}
              onClick={() => {
                setReadId(item._id);
                readNotification();
              }}
            >
              {item?.message}
            </p>
            <p
              style={{
                fontSize: "12px",
                color: "#4A4A4A",
                marginTop: "12px",
                margin: 0,
              }}
            >
              {/* {moment(item?.createdAt).calendar()} */}
            </p>
          </div>
        );
      })}
      <div
        style={{
          borderBottom: "0.8px solid #4A4A4A80",
        }}
      />
    </div>
  }
></ModalBox>
  
      </>
  );
}
